import React, { useState } from 'react'
import "./StickyMenu3.css"
import {globals} from '../Globals/Globals'
import ToolBoxButton from '../ToolboxButton/ToolBoxButton'

import default_icon from '../../Assets/img/icon/Logo-Le-Cercle.svg'
import immo_icon from '../../Assets/img/plateform-logo/logo_immo.png'
import toolbox_icon from '../../Assets/img/plateform-logo/logo-Toolbox.png'
import finance_icon from '../../Assets/img/plateform-logo/logo_finance.png'
import events_icon from '../../Assets/img/plateform-logo/logo-event.png'
import rh_icon from '../../Assets/img/plateform-logo/logo_rh.png'
import frFlag from '../../Assets/img/icon/fr-flag.svg'

function StickyMenu3 (props) {
    let navbar_top_ref = React.createRef();
    let navbar_intitial_offset_top = -1;
    let [Toggle,setToggle] = useState(false);
    let [Collapsed,setCollapsed] = useState(true);
    //let [navBackColor,setNavBackColor] = useState(props.navBackColor?props.navBackColor:"transparent");
    let [navBackColor,setNavBackColor] = useState(props.navBackColor?props.navBackColor:"black");//Force back color to black
    let [scrollTriggerCeil,setScrollTriggerCeil] = useState(props.scrollTriggerCeil?props.scrollTriggerCeil:40);

    React.useEffect(
        () => {
            /* Patch add on 2025-08-04 to auto add padding-top */
            if (props.auto_padding){
                // add padding top to show content behind navbar
                let navbar_height = navbar_top_ref.current.offsetHeight;
                document.body.style.paddingTop = navbar_height + 'px';
            }
            /* end of patch */

            window.addEventListener('scroll', function() {
                if (navbar_top_ref.current){
                    if (navbar_intitial_offset_top == -1){
                        console.clear()
                        navbar_intitial_offset_top = navbar_top_ref.current.offsetTop;

                    }
                    
                    if (globals.parameters.sticky3_debug){
                        //console.clear()
                        console.log("window.scrollY => ", window.scrollY)
                        console.log("navbar_intitial_offset_top => ", navbar_intitial_offset_top)
                        console.log("navbar_top_ref.current.offsetTop => ", navbar_top_ref.current.offsetTop)
                    }

                    //Stick process
                    if (window.scrollY > navbar_intitial_offset_top) {
                        navbar_top_ref.current.classList.add('fixed-menu-top');

                        if (!props.auto_padding){
                            // add padding top to show content behind navbar
                            let navbar_height = navbar_top_ref.current.offsetHeight;
                            document.body.style.paddingTop = navbar_height + 'px';
                        }
                    } else {
                        navbar_top_ref.current.classList.remove('fixed-menu-top');

                        // remove padding top from body
                        //Disabled on 2025-08-04 if (!props.auto_padding) document.body.style.paddingTop = '0';
                    }

                    //Back Color process
                    if (window.scrollY > scrollTriggerCeil) {
                        //Change back color as scroll position is greater than nav bar heigth

                        //Set scrollabled background color
                        if (globals.parameters.sticky3_debug)
                            console.log("set Opaque")
                            
                        setNavBackColor(props.navBackScrolledColor?props.navBackScrolledColor:"black");
                    } else {
                        //Restore initial background color
                        if (globals.parameters.sticky3_debug)
                            console.log("set Transparent")

                        //setNavBackColor(props.navBackColor?props.navBackColor:"transparent");
                        setNavBackColor(props.navBackColor?props.navBackColor:"black");//Force back color to black
                    }
                }
            });
        }
    )

    const rendering = () => {
        return(
            <>
                <nav 
                    ref={navbar_top_ref} 
                    id="navbar_top" 
                    class="navbar navbar-expand-lg navbar-dark p-0"
                    style={{backgroundColor:`${navBackColor}`}}
                    >
                    <div class="container-fluid px-0">
                        <a class="navbar-brand" href="/">
                            <div className='platform-logo'/>
                        </a>

                        {/*
                        <a class="navbar-brand" href="/">Jésus est la réponse</a>
                        */}

                        <button onClick={()=>{setCollapsed(!Collapsed);}} class={`navbar-toggler ${Collapsed?"collapsed":""}`} type="button" data-toggle="collapse" data-bs-target="#main_nav" aria-expanded={`${Toggle?"true":"false"}`} aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon-green"></span>
                        </button>
                        <div class={`collapse navbar-collapse ${Collapsed?"collapse":"collapse show"}`} id="main_nav">
                            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <ToolBoxButton
                    icon={immo_icon}
                    caption={"immo"}
                    color={"#69b42e"}
                    url={"https://www.hotels.immo/"}
                    pictureURL={globals.dico.immo_icon}
                    text={`
                    <div class="toolbox-text">
                    <Strong>plateforme Immobilier</Strong> <br/>
                    <p>Achetez ou vendez un hôtel en direct, sans intermédiaire et sans commission.</p>
                    </div>
                    `}
                    />
                </li>

                <li class="nav-item">
                    <ToolBoxButton
                        icon={toolbox_icon}
                        caption={"toolbox"}
                        color={"#346499"}
                        url={"https://www.toolbox-thcc.com/"}
                        pictureURL={globals.dico.toolbox_icon}
                        text={`
                            <div class="toolbox-text">
                                <Strong>plateforme Boîte à Outils</Strong> <br/>
                                <p>Prenez rendez-vous gratuitement avec des experts externes et bénéficiez d'avantages exclusifs.</p>
                            </div>
                            `}
                    />
                </li>

                <li class="nav-item">
                    <ToolBoxButton
                        icon={finance_icon}
                        caption={"finance"}
                        color={"#f39200"}
                        url={"https://www.hotels.immo/"}
                        pictureURL={globals.dico.finance_icon}
                        text={`
                            <div class="toolbox-text">
                                <Strong>plateforme financement</Strong> <br/>
                                <p>Recherche de financement auprès de banquiers privés ou private equity. pas de commission.
                                </p>
                            </div>
                            `}
                    />
                </li>
                
                <li class="nav-item">
                    <ToolBoxButton
                        icon={events_icon}
                        caption={"event"}
                        color={"#cc1780"}
                        url={"https://www.lecercle-hotels-events.com/"}
                        pictureURL={globals.dico.event_icon}
                        text={`
                            <div class="toolbox-text">
                                <Strong>plateforme Evenements</Strong> <br/>
                                <p>Echanges et partages entre professionnels lors d'événements locaux ou internationaux.</p>
                            </div>
                            `}
                    />
                </li>
              
                <li class="nav-item">
                    <ToolBoxButton
                        icon={rh_icon}
                        caption={"rh"}
                        color={"#a19f4f"}
                        url={"https://www.lecercle-hotels.com/contact"}
                        pictureURL={globals.dico.event_icon}
                        text={`
                            <div class="toolbox-text">
                                <Strong>plateforme RH</Strong> <br/>
                                <p>Déposez des offres d'emploi, recrutez du staff, fidélisez le, formation et conseils RH.</p>
                                <i>Ouverture 1<sup>er</sup> trimestre 2026</i>
                            </div>
                            `}
                    />
                </li>

                <li class="nav-item member-button-item">
                    <ToolBoxButton
                        class={"member-button"}
                        caption={"Contact"}
                        color={"#b3a356"}
                        url={"https://www.lecercle-hotels.com/contact"}
                        pictureURL={globals.dico.member_icon}
                        text={`
                            <div class="toolbox-text">
                                <Strong>Adhésion au Cercle</Strong> <br/>
                                <p>Vous êtes hôtelier, comment nous rejoindre ?</p>
                            </div>
                            `}
                    />
                </li>
                    <li class="nav-item lang-item">
                        <div class="nav-item lang-fr" style={{cursor: 'default'}}>
                            <span>fr</span>
                            <img class="lang-flag" src={frFlag} alt="Français" />
                        </div>
                    </li>
                            </ul>

                        </div> {/*<!-- navbar-collapse.// -->*/}
                    </div> {/*<!-- container-fluid.// -->*/}
                </nav>
            </>
        )
    } 

    return(
        <>
            {rendering()}
        </>
    )
}

export default StickyMenu3;